export interface InformationalVideo {
    id: number;
    page: string;
    video_url: string;
    thumbnail_url?: string;
    header_text?: string;
    body_text?: string;
    documentation_url?: string;
}

export enum Page {
    VmsMap = "VmsMap",
    VmsStream = "VmsStream",
    VmsHistory = "VmsHistory",
}
